import { DOWNLOAD_EXCEL_PATHS } from '../constants';

export function getExcelDownloadApiPath(table, query, tableQuery) {
  let path = `/${DOWNLOAD_EXCEL_PATHS[table]}`;

  if (query) {
    path += query;
  }
  if (tableQuery) {
    path += tableQuery;
  }

  return path;
}

export default function getExcelDownloadURL(table, query, tableQuery) {
  const tokkoBrokerHost = localStorage.getItem('tokkoBrokerHost');
  const apiPath = getExcelDownloadApiPath(table, query, tableQuery);
  return `${tokkoBrokerHost}${apiPath}`;
}
